const SvgCurrency = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.25C6.60059 2.25 2.25 6.60059 2.25 12C2.25 14.2646 3.03809 16.3594 4.3125 18H2.25V19.5H6.75V15H5.25V16.7109C4.29199 15.3662 3.75 13.7578 3.75 12C3.75 7.42383 7.42383 3.75 12 3.75C13.3506 3.75 14.625 4.04004 15.75 4.64062V3C14.625 2.54883 13.3506 2.25 12 2.25ZM17.25 4.5V9H18.75V7.28906C19.708 8.63379 20.25 10.2422 20.25 12C20.25 16.5762 16.5762 20.25 12 20.25C10.6494 20.25 9.375 19.96 8.25 19.3594V21C9.375 21.4512 10.6494 21.75 12 21.75C17.3994 21.75 21.75 17.3994 21.75 12C21.75 9.73535 20.9619 7.64062 19.6875 6H21.75V4.5H17.25ZM11.25 6V7.52344C9.9873 7.71094 9 8.8125 9 10.125C9 11.5664 10.1836 12.75 11.625 12.75H12.375C13.0312 12.75 13.5 13.2188 13.5 13.875C13.5 14.5312 13.0312 15 12.375 15H9.75V16.5H11.25V18H12.75V16.4766C14.0127 16.2891 15 15.1875 15 13.875C15 12.4336 13.8164 11.25 12.375 11.25H11.625C10.9688 11.25 10.5 10.7812 10.5 10.125C10.5 9.46875 10.9688 9 11.625 9H14.25V7.5H12.75V6H11.25Z"
        className="fill-current"
      />
    </svg>
  );
};

export default SvgCurrency;
